import { render } from "./BusinessInvoiceNew.vue?vue&type=template&id=490032c9&ts=true"
import script from "./BusinessInvoiceNew.vue?vue&type=script&lang=ts"
export * from "./BusinessInvoiceNew.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__